module.exports = __webpack_public_path__ + "img/equityUsage.db695a7a.png";